var map = {
	"./k_sleep_ca.webp": 700140,
	"./k_sleep_cn.webp": 74914,
	"./k_sleep_de.webp": 720427,
	"./k_sleep_es.webp": 759084,
	"./k_sleep_fr.webp": 41647,
	"./k_sleep_it.webp": 663349,
	"./k_sleep_jp.webp": 845328,
	"./k_sleep_kr.webp": 887974,
	"./k_sleep_us.webp": 715149
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13082;